<template>

    <div class="publication__editor content-width">

        <div class="publication__editor-wrap  d-flex">
            <div class="publication__editor-item">
                <div class="publication__fieldset">
                    <div class="publication__fieldset-title">Название проекта</div>
                    <div class="publication__fieldset-input">
                        <input type="text" v-model="$v.name.$model" placeholder="Введите название проекта">
                    </div>
                    <div class="text-danger" v-show="$v.name.$error">Неверное значение.</div>
                </div>
                <div class="publication__fieldset publication__fieldset--textarea-medium">
                    <div class="publication__fieldset-title">Подзаголовок объявления в каталоге (до 80 символов)</div>
                    <div class="publication__fieldset-input">
                        <textarea v-model="$v.ad_title.$model" placeholder="Введите текст для каталога"></textarea>
                    </div>
                    <div class="text-danger" v-show="$v.ad_title.$error">Неверное значение.</div>
                </div>
                <div class="publication__fieldset publication__fieldset--textarea-large" v-if="provideStep === server.idx">
                    <div class="publication__fieldset-title">Информация о проекте (до 3000 символов)</div>
                    <quill-editor
                        class="publication__fieldset-input"
                        v-model="$v.description.$model"
                        :options="editorOption"
                    />
                    <div class="text-danger" v-show="$v.description.$error">Неверное значение.</div>
                </div>
            </div>
            <div class="publication__editor-item d-flex">
                <div class="publication__fieldset d-flex">
                    <div class="publication__fieldset-title">
                        Предпросмотр объявления
                    </div>
                    <div class="publication__fieldset-placeholder d-flex">
                        <div class="publication__fieldset-placeholder-card">

                            <div class="publication__fieldset-placeholder-avatar">
                                <img src="" alt="">
                            </div>

                            <div class="publication__fieldset-placeholder-title d-flex">
                                <div class="publication__fieldset-placeholder-name">{{ name || 'Введите название проекта' }}</div>
                                <div class="publication__fieldset-placeholder-location">
                                    <span class="lnr lnr-map-marker"></span>
                                    {{selectedCity.name}}
                                </div>
                            </div>

                            <div class="publication__fieldset-placeholder-description">{{ ad_title || 'Введите текст для каталога' }}</div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>

import { quillEditor } from 'vue-quill-editor';

import { required, maxLength } from 'vuelidate/lib/validators';
import StateMixin from "../mixins/StateMixin";

export default {
    name: "PublicationPreview",
    props: ['server'],
    inject: ['step'],
    mixins: [StateMixin],
    components: { quillEditor },
    data(){
        return{
            editorOption: {
                modules: {
                    toolbar: [['bold', 'italic', 'underline','blockquote'],[{ 'list': 'ordered'}, { 'list': 'bullet' }]]
                },
                placeholder: 'Введите общий текст для объявления',
                theme: 'snow'
            },
        }
    },
    computed:{
        provideStep(){
            return this.step();
        },
        name: {
            get() { return this.GET_BY_KEY('name') },
            set( val ) {
                this.SET_BY_KEY({key: 'name', data: val})
            }
        },

        ad_title: {
            get() { return this.GET_BY_KEY('ad_title') },
            set( val ) {
                this.SET_BY_KEY({key: 'ad_title', data: val})
            }
        },

        description: {
            get() { return this.GET_BY_KEY('description') },
            set( val ) {
                this.SET_BY_KEY({key: 'description', data: val})
            }
        },

        selectedCity(){ return this.GET_BY_KEY('selectedCity') },

    },

    methods:{

        isValid(){
            this.$v.$touch();

            if( this.$v.$invalid ){
                this.$emit('parent-update', false );
                return false
            }

            this.$emit('parent-update', true )
            return true

        }
    },

    validations: {
        name:        { required },
        ad_title:    { required, maxLength: maxLength(80) },
        description: { required, maxLength: maxLength(3000) },
    }

}
</script>

<style scoped>

</style>
